import React, {Component} from 'react';
import {Row, Col, Input, Button, Tabs, message, Card, Table, Checkbox} from 'antd';
import {getCookie, setCookie, deleteCookie, graphQLToken, graphQLURL, restApiEndpoint} from '../../utils/common';
import {StyledContent} from "../../styles/mixins";
const TabPane = Tabs.TabPane;

const roles = ['tools:admin', 'tools:beta', 'tools:dev', 'tools:portfolio', 'tools:user', 'user.coaching', 'user:edu', 'user:free', 'user:trial']

const overRideRolesList = [
  { name: roles[0], application: 'OptionsEDU Tools', description: 'Access to admin tools' },
  { name: roles[1], application: 'OptionsEDU Tools', description: 'Beta user permission the OptionsEDU' },
  { name: roles[2], application: 'OptionsEDU Tools', description: 'Developer user permission' },
  { name: roles[3], application: 'OptionsEDU Tools', description: 'Access to the portfolio section' },
  { name: roles[4], application: 'OptionsEDU Tools', description: 'User permission for the OptionsEDU' },
  { name: roles[5], application: 'OptionsEDU Tools', description: 'user.coaching' },
  { name: roles[6], application: 'OptionsEDU Tools', description: 'Access to education sections' },
  { name: roles[7], application: 'OptionsEDU Tools', description: 'Free Access to OptionsEDU' },
  { name: roles[8], application: 'OptionsEDU Tools', description: 'Trial User' }
]


class adminSettings extends Component {
  
  state = {
    apiUrl: 'https://api.optionsedu.com/graphql',
    graphQLURL: graphQLURL,
    securityToken: graphQLToken,
    restApiUrl: restApiEndpoint(),
    selectedRoles: []
  }
  
  componentWillMount() {
    const {apiUrl, graphQLURL, securityToken} = this.state;
    const apiUrlCookie = getCookie('apiUrl') || apiUrl
    const graphQLURLCookie = getCookie('graphQLURL') || graphQLURL
    const securityTokenCookie = getCookie('securityToken') || securityToken
    this.onSetRoles()
    this.setState({
      apiUrl: apiUrlCookie,
      graphQLURL: graphQLURLCookie,
      securityToken: securityTokenCookie,
    });
  }

  onSetRoles = () => {
    const { selectedRoles } = this.state
    const getRoles = localStorage.getItem("permissions")
    const getOveRideRoles = localStorage.getItem("overrideRole")
    const rolesList = getOveRideRoles || getRoles || ""
    roles.forEach(role => {
      if(rolesList.includes(role)) {
        selectedRoles.push(role)
      }
    })
    this.setState({selectedRoles})
  }
  
  onDelete = () => {
    deleteCookie('apiUrl')
    this.setState({
      apiUrl: 'https://api.optionsedu.com/graphql'
    })
    message.success('Graph cms url is deleted now!');
  }
  
  onSave = () => {
    setCookie('apiUrl',this.state.apiUrl, 7);
    message.success('Graph cms url is saved now!');
  }
  
  onSaveGraphQL = () => {
    setCookie('graphQLURL',this.state.graphQLURL, 7);
    setCookie('securityToken',this.state.securityToken, 7);
    message.success('GraphQL api endpoint is saved now!');
  }
  
  onDeleteGraphQL = () => {
    deleteCookie('graphQLURL');
    deleteCookie('securityToken');
    this.setState({
      graphQLURL: graphQLURL,
      securityToken: graphQLToken
    })
    message.success('GraphQL api endpoint is reset now!');
  }
  
  onSaveRest = () => {
    setCookie('operationApi',this.state.restApiUrl, 7);
    message.success('Rest api endpoint is saved now!');
  }
  
  onDeleteRest = () => {
    deleteCookie('operationApi');
    this.setState({
      restApiUrl: restApiEndpoint(),
    })
    message.success('Rest api endpoint is reset now!');
  }

  onChange = (event) => {
    let { selectedRoles } = this.state
    const { checked, name } = event.target
    if(!checked) {
      selectedRoles = selectedRoles.filter(role => role !== name)
    } else {
      selectedRoles.push(name)
    }
    this.setState({selectedRoles})
  }

  positionColumns = () => [
    { name: 'Vega', title: '', dataIndex: '', render: (text) => { return (<Checkbox name={text.name} checked={this.state.selectedRoles.includes(text.name)} onChange={this.onChange}/>)} },
    { name: 'name', title: 'Name', dataIndex: 'name' },
    { name: 'application', title: 'Application', dataIndex: 'application' },
    { name: 'description', title: 'Description', dataIndex: 'description' }
  ]

  onOverrideRoleSave = () => {
    const { selectedRoles } = this.state
    const string = selectedRoles.join(" ")
    localStorage.setItem("overrideRole", string)
    window.location.reload()
  }
  
  render() {
    return (
      <StyledContent>
        <Row gutter={16}>
          <Col span={24}>
            <Card bordered={false} title='GraphQL URL'>
              <Input value={this.state.apiUrl} onChange={(e) => this.setState({
                apiUrl: e.target.value,
              })} />
              <div style={{marginTop: 20}}>
                <Button onClick={this.onSave}>Save</Button>
                <Button onClick={this.onDelete}>Delete</Button>
              </div>
            </Card>
            <br/>
            <Card bordered={false} title='Graph CMS URL'>
              <div>
                <Input placeHolder="Enter GraphQl Url" value={this.state.graphQLURL} onChange={(e) => this.setState({
                  graphQLURL: e.target.value,
                })} />
              </div>
            </Card>
            <br/>
            <Card bordered={false} title='Security Token'>
              <div>
                <Input placeHolder="Security Token" value={this.state.securityToken} onChange={(e) => this.setState({
                  securityToken: e.target.value,
                })} />
              </div>
              <div style={{marginTop: 20}}>
                <Button onClick={this.onSaveGraphQL}>Save</Button>
                <Button onClick={this.onDeleteGraphQL}>Delete</Button>
              </div>
            </Card>
            <br/>
            <Card bordered={false} title='Rest API Endpoint'>
              <div>
                <Input placeHolder="Security Token" value={this.state.restApiUrl} onChange={(e) => this.setState({
                  restApiUrl: e.target.value,
                })} />
              </div>
              <div style={{marginTop: 20}}>
                <Button onClick={this.onSaveRest}>Save</Button>
                <Button onClick={this.onDeleteRest}>Delete</Button>
              </div>
            </Card>
            <br/>
            <Card bordered={false} title='Override Role'>
              <div>
                <Table
                  columns={this.positionColumns()}
                  size={'small'}
                  dataSource={overRideRolesList}
                  pagination={false}
                />
              </div>
              <Button onClick={this.onOverrideRoleSave} style={{marginTop: 20}}>Save Override Role</Button>
            </Card>
          </Col>
        </Row>
      </StyledContent>
    )
  }
}

export default adminSettings;





// WEBPACK FOOTER //
// ./src/components/Admin/adminSettings.js